(() => {
async function init(root){
if(!root || root.dataset.initialized) return;
const configNode=root.querySelector('[data-bundle-config]');
if(!configNode) return;
let config;
try {config=JSON.parse(configNode.textContent);} catch(error) {
  const message=root.querySelector('#bundleError');
  if(message){message.textContent='Products could not load. Please refresh the page or contact the store.';message.hidden=false;}
  console.error('Naari bundle: invalid product data',error);
  return;
}
root.dataset.initialized='true';
// Follow Shopify pagination so the catalog is not limited to its first 250 products.
try {
  const visited=new Set();
  let next=config.nextProductsUrl;
  while(next && root.isConnected){
    const url=new URL(next,window.location.href);
    url.searchParams.set('section_id',config.sectionId);
    if(url.origin!==window.location.origin || visited.has(url.href)) throw new Error('Invalid catalog pagination');
    visited.add(url.href);
    const response=await fetch(url.href);
    if(!response.ok) throw new Error('Unable to load all products');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const node=doc.querySelector('[data-bundle-config]');
    if(!node) throw new Error('Missing product data');
    const page=JSON.parse(node.textContent);
    config.products.push(...page.products);
    next=page.nextProductsUrl;
  }
} catch(error) {
  const message=root.querySelector('#bundleError');
  if(message){message.textContent='Some products could not load. Refresh the page to see all designs.';message.hidden=false;}
  console.error('Naari bundle: catalog loading failed',error);
}
if(!root.isConnected) return;
config.products=[...new Map(config.products.map(product=>[product.id,product])).values()];
const products=config.products.filter(p=>p.variants.length);
const normalizeTag=value=>String(value || '').trim().toLowerCase();
const productTags=new Map(products.map(p=>[p.id,(Array.isArray(p.tags)?p.tags:String(p.tags || '').split(',')).map(normalizeTag)]));
const chipbar=root.querySelector('#chipbar');
const categoryPatterns={
  fun: /\b(fun|quirky|pop art|starry|book|books|cat|cats|punctuation|pagal|quote|quotes|retro)\b/i,
  floral: /\b(floral|flower|flowers|sunflower|bloom|blossom|petal|petals|lotus|rose|daisy|tulip)\b|rainbow leaf/i,
  nature: /\b(nature|leaf|leaves|peacock|feather|bird|birds|toucan|butterfly|maple|autumn|tropical)\b/i,
  spiritual: /\b(spiritual|ganesh|ganesha|devi|karma|ram|rama|sita|krishna|divine|om|shiva|hanuman|buddha)\b/i,
  mandala: /\b(mandala|mandalas|yin yang)\b/i
};
function matchesCategory(p,filter){
  if(filter==='all') return true;
  const manual=normalizeTag(p.categoryOverride);
  if(Object.hasOwn(categoryPatterns,filter) && manual && manual!=='auto') return manual===filter;
  const chip=[...chipbar.querySelectorAll('[data-cat]')].find(button=>button.dataset.cat===filter);
  const tags=(chip?.dataset.tags || filter).split(',').map(normalizeTag).filter(Boolean);
  if(tags.some(tag=>productTags.get(p.id).includes(tag) || normalizeTag(p.cat)===tag)) return true;
  // Infer only the built-in categories; custom tag tabs remain exact matches.
  const pattern=categoryPatterns[filter];
  const text=[p.name,p.cat,...productTags.get(p.id)].join(' ').replace(/[-_]/g,' ');
  return pattern ? pattern.test(text) : false;
}
const bundleBar=root.querySelector('.bundlebar');
const measureBar=()=>root.style.setProperty('--bundle-bar-space',Math.ceil(bundleBar.getBoundingClientRect().height+32)+'px');
measureBar();
const barObserver=typeof ResizeObserver!=='undefined' ? new ResizeObserver(measureBar) : null;
barObserver?.observe(bundleBar);

const money=value=>new Intl.NumberFormat(document.documentElement.lang || 'en-IN',{style:'currency',currency:config.currency,maximumFractionDigits:2}).format(value/100);
const escapeHTML=value=>String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const fallbackImage='data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect width="400" height="400" fill="%23f4f0e4"/%3E%3C/svg%3E'.replaceAll('"','%22');
const variantChoices=new Map();
const variantFor=p=>p.variants.find(v=>v.id===variantChoices.get(p.id)) || p.variants.find(v=>v.available) || p.variants[0];
let wishlist=new Set(); try {wishlist=new Set(JSON.parse(localStorage.getItem('naari-wishlist') || '[]'));} catch {}
let wishlistOnly=false,busy=false,cartReady=false,checkoutCart=null;
const imgIndexMap = new Map();
const selected = new Set();
const quantities = new Map();
const quantityFor=id=>quantities.get(id) || 1;
const selectionStorageKey='naari-bundle-selection-v1:'+window.location.pathname+':'+root.id;
let cartRevision=0;
function saveSelection(){
  try {
    const items=[...selected].map(id=>({productId:id,variantId:variantFor(products.find(p=>p.id===id)).id,quantity:quantityFor(id)}));
    if(items.length) localStorage.setItem(selectionStorageKey,JSON.stringify(items));
    else localStorage.removeItem(selectionStorageKey);
  } catch {} // Browsers that block storage can still use the bundle builder.
}
function restoreSelection(){
  try {
    const items=JSON.parse(localStorage.getItem(selectionStorageKey) || '[]');
    if(!Array.isArray(items)) return;
    items.forEach(item=>{
      const product=products.find(p=>p.id===item?.productId);
      const variant=product?.variants.find(v=>v.id===item.variantId && v.available);
      if(!variant) return;
      variantChoices.set(product.id,variant.id);
      selected.add(product.id);
      quantities.set(product.id,Math.max(1,Math.floor(Number(item.quantity)||1)));
    });
  } catch {}
}
async function restoreCart(){
  const revision=cartRevision;
  try {
    const response=await fetch(config.root+'cart.js',{headers:{'Accept':'application/json'},cache:'no-store'});
    if(!response.ok) return;
    const currentCart=await response.json();
    // A slow initial request must not overwrite a newer checkout response.
    if(revision!==cartRevision || !root.isConnected) return;
    checkoutCart=currentCart;
    cartReady=currentCart.item_count>0;
    window.cart=currentCart;
    updateBar();
  } catch {} // Preserve the local selection when the cart cannot be reached.
}
const grid = root.querySelector("#" + 'grid');
const showMoreBtn = root.querySelector("#" + 'showMoreBtn');
const searchInput = root.querySelector("#" + 'searchInput');
const BATCH = 8;
let visibleCount = BATCH;
let viewMode = 'grid';
let searchTerm = '';

function offerEligible(p){
  const text=[p.name,p.cat,...(productTags.get(p.id)||[]),variantFor(p).title].join(' ').replace(/[-_]/g,' ');
  return !/\b(combo|combos|bundle|bundles|pack|packs|set|sets)\b|\b[2-9]\d*\s*pairs?\b|\bpair\s+product\b/i.test(text);
}
function eligibleCount(){
  return [...selected].reduce((sum,id)=>sum+(offerEligible(products.find(p=>p.id===id))?quantityFor(id):0),0);
}
function priceFor(){
  let eligibleSubtotal=0,excludedSubtotal=0;
  for(const id of selected){
    const p=products.find(p=>p.id===id),amount=variantFor(p).price*quantityFor(id);
    if(offerEligible(p)) eligibleSubtotal+=amount; else excludedSubtotal+=amount;
  }
  const n=eligibleCount();
  if(!config.estimates || n<3) return eligibleSubtotal+excludedSubtotal;
  const tier=n>=7?2:n>=5?1:0,size=[3,5,7][tier];
  return excludedSubtotal+Math.min(eligibleSubtotal,Math.round(config.tiers[tier]+(n-size)*config.extras[tier]));
}
function unitLabel(n){return n ? money(priceFor(n)/n) + '/pair' : 'total';}
function nextGap(n){
  if (!config.estimates) return null;
  const index = [3,5,7].findIndex(size=>n<size);
  return index<0 ? null : {need:[3,5,7][index]-n,rate:money(config.tiers[index]/[3,5,7][index])};
}
function renderGrid(filter){
  grid.innerHTML = '';
  grid.classList.toggle('carousel-mode', viewMode === 'carousel');
  const filtered = products.filter(p =>
    matchesCategory(p,filter) && (!wishlistOnly || wishlist.has(p.id)) &&
    p.name.toLowerCase().includes(searchTerm)
  );
  const status=root.querySelector('[data-filter-status]');
  if(status) status.textContent=filtered.length + (filtered.length===1 ? ' design' : ' designs');
  const toShow = viewMode === 'carousel' ? filtered : filtered.slice(0, visibleCount);
  toShow.forEach(p=>{
    const idx = imgIndexMap.get(p.id) || 0;
    const card = document.createElement('div');
    card.className = 'card' + (selected.has(p.id) ? ' added' : '');
    const dotsHtml = p.imgs.length > 1
      ? `<div class="imgdots">${p.imgs.map((_,i)=>`<button type="button" aria-label="Image ${i+1}" class="dot ${i===idx?'active':''}" data-pid="${p.id}" data-idx="${i}"></button>`).join('')}</div>
         <button aria-label="Previous image" class="imgarrow left" data-pid="${p.id}" data-dir="-1">‹</button>
         <button aria-label="Next image" class="imgarrow right" data-pid="${p.id}" data-dir="1">›</button>`
      : '';
    card.innerHTML = `
      <div class="imgwrap" data-pid="${p.id}">
        <img src="${escapeHTML(p.imgs[idx] || fallbackImage)}" loading="lazy" alt="${escapeHTML(p.name)}">
        ${dotsHtml}
      </div>
      <div class="name">${escapeHTML(p.name)}</div>
      <div class="price">${money(variantFor(p).price)}</div>
      <button class="addbtn" aria-label="${selected.has(p.id) ? 'Remove' : 'Add'} ${escapeHTML(p.name)}" ${variantFor(p).available ? '' : 'disabled'}>${selected.has(p.id) ? '✓' : '+'}</button>
    `;
    const favorite = document.createElement('button');
    favorite.className = 'favorite';
    favorite.textContent = wishlist.has(p.id) ? '♥' : '♡';
    favorite.setAttribute('aria-label', 'Save ' + p.name);
    favorite.setAttribute('aria-pressed', String(wishlist.has(p.id)));
    favorite.onclick = () => { wishlist.has(p.id) ? wishlist.delete(p.id) : wishlist.add(p.id); try { localStorage.setItem('naari-wishlist', JSON.stringify([...wishlist])); } catch {} renderGrid(root.querySelector('.chip.active').dataset.cat); };
    card.appendChild(favorite);
    if(p.variants.length>1){
      const select = document.createElement('select');
      select.className='variant-select'; select.setAttribute('aria-label','Variant for '+p.name);
      p.variants.forEach(v=>{ const option = new Option(v.title + (v.available ? '' : ' — Sold out'),v.id); option.disabled=!v.available; select.add(option); });
      select.value=variantFor(p).id;
      select.onchange=()=>{ if(busy) return; variantChoices.set(p.id,Number(select.value)); renderGrid(root.querySelector('.chip.active').dataset.cat); updateBar(); };
      card.appendChild(select);
    }
    if(!variantFor(p).available) card.querySelector('.price').textContent='Sold out';
    card.querySelector('.addbtn').addEventListener('click', (e)=>{
      e.stopPropagation();
      if(busy) return;
      if(selected.has(p.id)){ selected.delete(p.id); quantities.delete(p.id); } else { selected.add(p.id); quantities.set(p.id,1); }
      renderGrid(root.querySelector('.chip.active').dataset.cat);
      updateBar();
    });
    if(p.imgs.length > 1){
      card.querySelectorAll('.dot').forEach(d=>{
        d.addEventListener('click', (e)=>{
          e.stopPropagation();
          imgIndexMap.set(p.id, parseInt(d.dataset.idx));
          renderGrid(root.querySelector('.chip.active').dataset.cat);
        });
      });
      card.querySelectorAll('.imgarrow').forEach(btn=>{
        btn.addEventListener('click', (e)=>{
          e.stopPropagation();
          const dir = parseInt(btn.dataset.dir);
          const cur = imgIndexMap.get(p.id) || 0;
          imgIndexMap.set(p.id, (cur + dir + p.imgs.length) % p.imgs.length);
          renderGrid(root.querySelector('.chip.active').dataset.cat);
        });
      });
      const imgwrapEl = card.querySelector('.imgwrap');
      let touchStartX = 0;
      imgwrapEl.addEventListener('touchstart', e=>{ touchStartX = e.touches[0].clientX; });
      imgwrapEl.addEventListener('touchend', e=>{
        const dx = e.changedTouches[0].clientX - touchStartX;
        if(Math.abs(dx) > 30){
          const cur = imgIndexMap.get(p.id) || 0;
          const dir = dx < 0 ? 1 : -1;
          imgIndexMap.set(p.id, (cur + dir + p.imgs.length) % p.imgs.length);
          renderGrid(root.querySelector('.chip.active').dataset.cat);
        }
      });
    }
    grid.appendChild(card);
  });
  if(filtered.length === 0){
    grid.innerHTML = '<p style="opacity:.6; font-weight:600; padding:20px 0;">No designs match these filters — try another tab or search.</p>';
  }
  showMoreBtn.hidden = viewMode === 'carousel' || visibleCount >= filtered.length;
}

showMoreBtn.addEventListener('click', ()=>{
  visibleCount += BATCH;
  renderGrid(root.querySelector('.chip.active').dataset.cat);
});

searchInput.addEventListener('input', (e)=>{
  searchTerm = e.target.value.trim().toLowerCase();
  visibleCount = BATCH;
  renderGrid(root.querySelector('.chip.active').dataset.cat);
});

root.querySelector("#" + 'viewGridBtn').addEventListener('click', ()=>{
  viewMode = 'grid';
  root.querySelector("#" + 'viewGridBtn').classList.add('active');
  root.querySelector("#" + 'viewCarouselBtn').classList.remove('active');
  root.querySelector("#" + 'carouselNav').style.display = 'none';
  renderGrid(root.querySelector('.chip.active').dataset.cat);
});
root.querySelector("#" + 'viewCarouselBtn').addEventListener('click', ()=>{
  viewMode = 'carousel';
  root.querySelector("#" + 'viewCarouselBtn').classList.add('active');
  root.querySelector("#" + 'viewGridBtn').classList.remove('active');
  root.querySelector("#" + 'carouselNav').style.display = 'flex';
  renderGrid(root.querySelector('.chip.active').dataset.cat);
});
root.querySelector("#" + 'carPrev').addEventListener('click', ()=> grid.scrollBy({left:-460, behavior:'smooth'}));
root.querySelector("#" + 'carNext').addEventListener('click', ()=> grid.scrollBy({left:460, behavior:'smooth'}));

function totalsMarkup(original,total,label){
  return `<small>${label}</small><s>${money(original)}</s> <strong>${money(total)}</strong><small>Saved ${money(Math.max(0,original-total))}</small>`;
}
const itemPanel=root.querySelector('#bundleItems');
const itemList=root.querySelector('#bundleItemsList');
const toggleItems=root.querySelector('#toggleBundleItems');
function setItemsOpen(open){
  itemPanel.hidden=!open;
  itemPanel.style.display=open ? 'block' : 'none';
  toggleItems.setAttribute('aria-expanded',String(open));
  toggleItems.setAttribute('aria-label',open ? 'Hide cart items' : 'Show cart items');
}
setItemsOpen(false);
let refreshingItems=false;
toggleItems.addEventListener('click',async()=>{
  const open=itemPanel.hidden;
  setItemsOpen(open);
  if(!open || refreshingItems || busy) return;
  refreshingItems=true;
  itemPanel.setAttribute('aria-busy','true');
  try {await restoreCart();}
  finally {refreshingItems=false;itemPanel.removeAttribute('aria-busy');}
});
root.querySelector('#closeBundleItems').addEventListener('click',()=>{setItemsOpen(false);toggleItems.focus();});
itemPanel.addEventListener('keydown',event=>{if(event.key==='Escape'){setItemsOpen(false);toggleItems.focus();}});
function renderItems(){
  const count=[...selected].reduce((sum,id)=>sum+quantityFor(id),0)+(checkoutCart?.item_count || 0);
  root.querySelector('#bundleCartCount').textContent=String(count);
  toggleItems.setAttribute('aria-label',`${itemPanel.hidden ? 'Show' : 'Hide'} cart items, ${count} items`);
  const pending=[...selected].map(id=>{
    const p=products.find(p=>p.id===id),v=variantFor(p);
    return {key:String(id),kind:'pending',title:p.name,variant:v.title,quantity:quantityFor(id),image:p.imgs[0],price:v.price*quantityFor(id)};
  });
  const saved=(checkoutCart?.items || []).map(item=>({key:item.key,kind:'cart',title:item.product_title || item.title,variant:item.variant_title,quantity:item.quantity,image:item.image,price:item.final_line_price}));
  itemList.innerHTML=[...saved,...pending].map(item=>`<div class="bundle-item" data-key="${escapeHTML(item.key)}" data-kind="${item.kind}">
    <img src="${escapeHTML(item.image || fallbackImage)}" alt="" width="48" height="48">
    <div class="bundle-item__info"><strong title="${escapeHTML(item.title)}">${escapeHTML(item.title)}</strong>${item.variant && item.variant!=='Default Title' ? `<small>${escapeHTML(item.variant)}</small>` : ''}<small>${item.kind==='pending' ? 'Selected · ' : 'In cart · '}${money(item.price)}</small>
    <div class="bundle-item__controls"><button type="button" data-item-action="minus" aria-label="Decrease quantity" ${busy?'disabled':''}>−</button><span>${item.quantity}</span><button type="button" data-item-action="plus" aria-label="Increase quantity" ${busy?'disabled':''}>+</button><button type="button" data-item-action="remove" aria-label="Remove ${escapeHTML(item.title)}" title="Remove item" ${busy?'disabled':''}><svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/></svg></button></div></div></div>`).join('') || '<p>No items selected yet.</p>';
}
itemList.addEventListener('click',async event=>{
  const button=event.target.closest('[data-item-action]');
  if(!button || busy) return;
  const row=button.closest('[data-key]'),action=button.dataset.itemAction;
  if(row.dataset.kind==='pending'){
    const id=Number(row.dataset.key);
    const quantity=action==='remove' ? 0 : quantityFor(id)+(action==='plus'?1:-1);
    if(quantity<=0){selected.delete(id);quantities.delete(id);} else quantities.set(id,quantity);
    renderGrid(root.querySelector('.chip.active').dataset.cat);updateBar();return;
  }
  const item=checkoutCart?.items.find(item=>item.key===row.dataset.key);
  if(!item) return;
  const quantity=action==='remove'?0:item.quantity+(action==='plus'?1:-1);
  busy=true;cartRevision++;updateBar();
  const error=root.querySelector('#bundleError');error.hidden=true;
  try {
    const response=await fetch(config.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:item.key,quantity})});
    const result=await response.json();
    if(!response.ok) throw new Error(result.description || result.message || 'Unable to update cart. Please try again.');
    checkoutCart=result;cartReady=result.item_count>0;window.cart=result;
  } catch(e){error.textContent=e.message;error.hidden=false;}
  finally {busy=false;updateBar();}
});

function updateBar(){
  saveSelection();
  const n = [...selected].reduce((sum,id)=>sum+quantityFor(id),0);
  const total = priceFor(n)+(checkoutCart?.total_price || 0);
  root.querySelector("#" + 'bbCount').textContent = n + (n===1 ? ' pair' : ' pairs');
  const original=[...selected].reduce((sum,id)=>sum+variantFor(products.find(p=>p.id===id)).price*quantityFor(id),0)+(checkoutCart?.original_total_price || 0);
  root.querySelector('#bbTotal').innerHTML = totalsMarkup(original,total,config.estimates || checkoutCart?.item_count ? 'Estimated total' : 'Total');
  const offerCount=eligibleCount();
  const gap = nextGap(offerCount);
  const msg = root.querySelector("#" + 'bbMsg');
  if(n===0){
    msg.textContent = config.estimates ? 'Add 3 single products to unlock ' + money(config.tiers[0]/3) + '/pair' : 'Pick your favourite pairs';
  } else if(gap){
    msg.textContent = `Add ${gap.need} more single product${gap.need>1?'s':''} to drop to ${gap.rate}/pair`;
  } else {
    msg.textContent = config.estimates ? 'Bundle estimate — final total at checkout' : 'Your pairs are ready. Discounts calculated at checkout.';
  }
  const fillPct = Math.min(100, (offerCount/7)*100);
  root.querySelector("#" + 'bbFill').style.width = fillPct + '%';
  const btn = root.querySelector("#" + 'checkoutBtn');
  btn.disabled = (n===0 && !cartReady) || busy;
  btn.textContent = n===0 ? (cartReady ? 'Continue checkout' : 'Add pairs to checkout') : `Checkout · ${money(total)}`;
  if(n===0 && cartReady){
    root.querySelector('#bbCount').textContent='Added to cart';
    root.querySelector('#bbMsg').textContent='Your pairs are in the cart. Continue checkout or select more designs.';
    root.querySelector('#bbTotal').innerHTML=checkoutCart ? totalsMarkup(checkoutCart.original_total_price,checkoutCart.total_price,'Cart total') : '<small>Ready to checkout</small>';
  }
  renderItems();
}

root.querySelector("#" + 'chipbar').addEventListener('click', (e)=>{
  const chip=e.target.closest('.chip');
  if(!chip || !chipbar.contains(chip)) return;
  chipbar.querySelectorAll('.chip').forEach(c=>{c.classList.toggle('active',c===chip);c.setAttribute('aria-pressed',String(c===chip));});
  visibleCount = BATCH;
  renderGrid(chip.dataset.cat);
});

async function openBundleCheckout(){
  if(config.gokwikEnabled){
    if(typeof window.onCheckoutClick!=='function' || !window.gokwikSdk){
      await new Promise(resolve=>{
        const ready=()=>{clearTimeout(timeout);window.removeEventListener('gokwikLoaded',ready);resolve();};
        const timeout=setTimeout(ready,4000);
        window.addEventListener('gokwikLoaded',ready,{once:true});
      });
    }
    if(typeof window.onCheckoutClick==='function' && window.gokwikSdk){
      // Use the store's existing merchant integration and its required loader element.
      window.onCheckoutClick(root.querySelector('[data-gokwik-trigger]'));
      return;
    }
  }
  window.location.assign(config.root+'checkout');
}
root.querySelector('#checkoutBtn').addEventListener('click', async function(){
  if(this.disabled || busy) return;
  cartRevision++;
  busy=true; this.disabled=true; this.textContent=selected.size ? 'Adding your pairs…' : 'Opening checkout…';
  const error=root.querySelector('#bundleError'); error.hidden=true;
  try {
    if(selected.size){
      const items=[...selected].map(id=>({id:variantFor(products.find(p=>p.id===id)).id,quantity:quantityFor(id)}));
      const response=await fetch(config.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if(!response.ok) throw new Error(result.description || result.message || 'Unable to add these pairs. Please try again.');
      // Clear only after a confirmed add, so reopening checkout never re-adds these pairs.
      selected.clear(); quantities.clear(); saveSelection(); cartReady=true;
      renderGrid(root.querySelector('.chip.active').dataset.cat);
    }
    const cartResponse=await fetch(config.root+'cart.js',{headers:{'Accept':'application/json'},cache:'no-store'});
    if(!cartResponse.ok) throw new Error('Your pairs are saved in the cart. Please try checkout again.');
    checkoutCart=await cartResponse.json();
    window.cart=checkoutCart;
    await openBundleCheckout();
  } catch(e) {
    error.textContent=e.message; error.hidden=false; error.scrollIntoView({behavior:'smooth',block:'center'});
  } finally {
    busy=false; updateBar();
  }
});
root.querySelector('#wishlistBtn').addEventListener('click',()=>{ wishlistOnly=!wishlistOnly; root.querySelector('#wishlistBtn').textContent=wishlistOnly ? 'All designs' : 'Wishlist'; renderGrid(root.querySelector('.chip.active').dataset.cat); });
root.querySelectorAll('.gobtn').forEach(btn=>{btn.removeAttribute('onclick');btn.addEventListener('click',()=>root.querySelector('#grid').scrollIntoView({behavior:'smooth'}));});

restoreSelection();
renderGrid('all');
updateBar();
restoreCart();

// offer bar: countdown to midnight + dismiss
function tickOffer(){
  const clockEl = root.querySelector("#" + 'offerClock');
  if(!clockEl) return;
  const now = new Date();
  const midnight = new Date(config.offerEnd);
  if(!config.offerEnd || Number.isNaN(midnight.getTime())) {clockEl.hidden=true; return;}
  const diff = Math.max(0, midnight - now);
  if(diff===0){root.querySelector("#offerBar").hidden=true; return;}
  const h = String(Math.floor(diff/3600000)).padStart(2,'0');
  const m = String(Math.floor((diff%3600000)/60000)).padStart(2,'0');
  const s = String(Math.floor((diff%60000)/1000)).padStart(2,'0');
  clockEl.textContent = `${h}:${m}:${s} left`;
}
tickOffer();
const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);barObserver?.disconnect();return;} tickOffer();}, 1000);
root.querySelector("#" + 'offerClose').addEventListener('click', ()=>{
  root.querySelector("#" + 'offerBar').style.display = 'none';
});

}
const initialize=()=>document.querySelectorAll('[data-naari-bundle]').forEach(init);
initialize();
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
if(!window.naariBundleSectionListener){
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-naari-bundle]').forEach(init));
  window.naariBundleSectionListener=true;
}
})();
